import AddSubscriptionModal from "./AddSubscriptionModal.tsx";
import AddBankAccountModal from "./AddBankAccountModal.tsx";
import ViewAccountDetails from "./ViewAccountDetails.tsx";
import EditSubscriptionModal from "./EditSubscription.tsx";
import AddLiveSubscriptionModal from "./AddLiveSubscription.tsx";
import RaiseInvoiceModal from "./RaiseInvoice.tsx";
import EditLiveSubscription from "./EditLiveSubscription.tsx";
import OrderMarkPaidConfirm from "./OrderMarkPaidConfirm.tsx";
import PauseLiveSubscription from "./PauseLiveSubscription.tsx";
import TerminateLiveSubscription from "./TerminateLiveSubscription.tsx";
import OrderSummary from "./orderSummary.tsx";
import RemindPaymentWhatsappModal from "./RemindPaymentWhatsappModal.tsx";
import EditProfileModal from "./EditProfileModal.tsx";
import CustomBrandingModal from "./CustomBrandingModal.tsx";
import AllBankAccountsModal from "./AllBankAccountsModal.tsx";
import WhatsappUnblockNotification from "./WhatsappUnblockNotification.tsx";
import EditCustomBranding from "./EditCustomBranding.tsx";
import FetchExistingSubscriptionModal from "./FetchExistingSubscriptionModal.tsx";
import QRCodeModal from "./QRCodeModal.tsx";
import BuyCreditsModal from "./BuyCreditsModal.tsx";
import DeleteLiveSubscriptionModal from "./DeleteLiveSubscriptionModal.tsx";
import PauseErrorModal from "./PauseErrorModal.tsx";
import ResumeLiveSubscriptionModal from "./ResumeLiveSubscriptionModal.tsx";
import AddOfferModal from "./AddOfferModal.tsx";
import EditOfferModal from "./EditOfferModal.tsx";
import AddTeamMemberModal from "./AddTeamMemberModal.tsx";
import RevokeRoleModal from "./RevokeRoleModal.tsx";
import AddEventsModal from "./AddEventsModal.tsx";
import EditEventsModal from "./EditEventsModal.tsx";
import QREventsandOfferModal from "./QREventsandOfferModal.tsx";
import MultiMonthPauseModal from "./MultiMonthPauseModal.tsx";
import MultiMonthResumeModal from "./MultiMonthResumeModal.tsx";
import CancelPauseSubscriptionModal from "./cancelPauseLiveSubscriptionModal.tsx";
import MMEditOrderModal from "./MMEditOrderModal.tsx";
import ExportPaymentsModal from "./ExportPaymentsModal.tsx";
import ExportAttendanceModal from "./ExportAttendanceModal.tsx";
import ExportStudentProgressModal from "./ExportStudentProgressModal.tsx";
import AddEventCustomFieldsModal from "./AddEventCustomFieldsModal.tsx";
import EditEventCustomFieldModal from "./EditEventCustomFieldModal.tsx";
import DeleteAdditionalFormFieldsModal from "./DeleteAdditionalFormFieldsModal.tsx";
import SingleRaiseInvoiceModal from "./SingleRaiseInvoiceModal.tsx";
import BulkRaiseInvoiceModal from "./BulkRaiseInvoiceModal.tsx";
import BulkRemindersModal from "./BulkRemindersModal.tsx";
import AddLeadModal from "./Inflow/AddLeadModal.tsx";
import EditLeadModal from "./Inflow/EditLeadModal.tsx";
import RoleSwitchModal from "../../Subscriptions/Components/Modals/RoleSwitchModal.tsx";
// Removed the problematic import statement

import CustomPlanPriceModal from "./CustomPlanPriceModal.tsx";
import QuickCollectModal from "./QuickCollectModal.tsx";
import EditorJSModal from "./EditorJSModal.tsx";
import ForceSwitchUserModal from "./ForceSwitchUserModal.tsx";
import CustomerKYCModal from "./CustomerKYCModal.tsx";
import AddCustomerKYCFieldModal from "./AddCustomerKYCFieldModal.tsx";
import EditCustomerKYCFieldModal from "./EditCustomerKYCFieldModal.tsx";
import DeleteCustomerKYCFieldModal from "./DeleteCustomerKYCFieldModal.tsx";
import MoveStudentModal from "./MoveStudentModal.tsx";
import DeleteBatchModal from "./DeleteBatchModal.tsx";


export default function ModalManager() {
    return (
        <div>
            <AddSubscriptionModal />
            <AddBankAccountModal />
            <ViewAccountDetails />
            <EditSubscriptionModal />
            <AddLiveSubscriptionModal />
            <RaiseInvoiceModal />
            <EditLiveSubscription />
            <OrderMarkPaidConfirm />
            <TerminateLiveSubscription />
            <PauseLiveSubscription />
            <OrderSummary />
            <RemindPaymentWhatsappModal />
            <EditProfileModal />
            <AllBankAccountsModal />
            <CustomBrandingModal />
            <EditCustomBranding />
            <WhatsappUnblockNotification />
            <FetchExistingSubscriptionModal />
            <QRCodeModal />
            <BuyCreditsModal />
            <DeleteLiveSubscriptionModal/>
            <PauseErrorModal/>  
            <ResumeLiveSubscriptionModal/>
            <AddOfferModal />
            <EditOfferModal offerId="" /> {/* Pass an empty string as a placeholder */}
            <AddTeamMemberModal />
            <RevokeRoleModal/>  
            <AddEventsModal/>
            <EditEventsModal/>
            <QREventsandOfferModal/>
            <MultiMonthPauseModal/>
            <MultiMonthResumeModal/>
            <CancelPauseSubscriptionModal/>
            <MMEditOrderModal/>
            <ExportPaymentsModal />
            <ExportAttendanceModal />
            <ExportStudentProgressModal />
            <AddEventCustomFieldsModal/>
            <EditEventCustomFieldModal/>
            <DeleteAdditionalFormFieldsModal/>
            <SingleRaiseInvoiceModal/> 
            <BulkRaiseInvoiceModal/>
            <BulkRemindersModal/>
            <AddLeadModal />
            <EditLeadModal lead={null} updateLead={() => {}} />
            <RoleSwitchModal />
            <CustomPlanPriceModal />
            <QuickCollectModal />
            <EditorJSModal />
            <ForceSwitchUserModal />
            <CustomerKYCModal />
            <AddCustomerKYCFieldModal />
            <EditCustomerKYCFieldModal />
            <DeleteCustomerKYCFieldModal />
            <MoveStudentModal />
            <DeleteBatchModal />

        </div>
    )
}




